import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

const SLIDER_MQ = window.matchMedia('(min-width: 768px)');
const swiperInstances = new Set();
let resizeTimer;

function scheduleSwiperUpdate() {
	clearTimeout(resizeTimer);
	resizeTimer = setTimeout(() => {
		swiperInstances.forEach((swiper) => {
			swiper.update();
			if (swiper.scrollbar) {
				swiper.scrollbar.updateSize();
			}
		});
	}, 150);
}

function initShopByCategorySlider(module) {
	const swiperEl = module.querySelector('.swiper');
	if (!swiperEl) {
		return;
	}

	if (!SLIDER_MQ.matches) {
		if (swiperEl.swiper) {
			swiperEl.swiper.destroy(true, true);
		}
		return;
	}

	const next = module.querySelector('.slider-nav-next');
	const prev = module.querySelector('.slider-nav-prev');
	const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');
	const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

	if (swiperEl.swiper) {
		swiperEl.swiper.destroy(true, true);
	}

	const swiperParams = {
		modules: [Navigation, Scrollbar],
		slidesPerView: 'auto',
		spaceBetween: 8,
		watchOverflow: true,
		navigation: {
			nextEl: next,
			prevEl: prev,
		},
		scrollbar: {
			el: scrollbarEl,
			draggable: true,
			hide: false,
		},
	};

	if (totalSlides <= 1 && next && prev) {
		next.style.display = 'none';
		prev.style.display = 'none';
	}

	const swiper = new Swiper(swiperEl, swiperParams);
	swiperInstances.add(swiper);

	if (swiper.scrollbar) {
		swiper.scrollbar.updateSize();
	}

	const stage = module.querySelector('.shop-by-category-stage');
	if (stage) {
		const updateSliderFades = () => {
			stage.classList.toggle('is-at-beginning', swiper.isBeginning);
			stage.classList.toggle('is-at-end', swiper.isEnd);
		};

		updateSliderFades();
		swiper.on('slideChange', updateSliderFades);
		swiper.on('resize', updateSliderFades);
		swiper.on('transitionEnd', updateSliderFades);
		swiper.on('scrollbarDragMove', updateSliderFades);
	}
}

function initShopByCategorySliders() {
	swiperInstances.clear();
	document.querySelectorAll('.module-shop-by-category').forEach(initShopByCategorySlider);
}

document.addEventListener('DOMContentLoaded', initShopByCategorySliders);
window.addEventListener('resize', scheduleSwiperUpdate);

if (typeof SLIDER_MQ.addEventListener === 'function') {
	SLIDER_MQ.addEventListener('change', initShopByCategorySliders);
} else {
	SLIDER_MQ.addListener(initShopByCategorySliders);
}
